import { IApplicationState } from '../../types/redux';

export const getBuilderChatGaLabel = (state: IApplicationState) => state.builderChat.gaLabel;
